import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { DeliveryAddressService } from '@checkout-v2/feature';
import { SdModalService } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { delay, merge } from 'rxjs';
import { DeliveryAddAddressComponent } from '../delivery-add-address';
import { DeliveryAddressComponent } from '../delivery-address';
import { DeliveryAddressDialogComponent } from '../delivery-address-dialog';

@Component({
  selector: 'sd-delivery-address-list',
  imports: [DeliveryAddAddressComponent, DeliveryAddressComponent],
  templateUrl: './delivery-address-list.component.html',
  styleUrls: ['./delivery-address-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveryAddressListComponent implements OnInit {
  private readonly deliveryAddressService = inject(DeliveryAddressService);
  private readonly modalService = inject(SdModalService);
  private readonly deviceService = inject(DeviceService);
  private readonly destroyRef = inject(DestroyRef);

  protected readonly addressList = toSignal(this.deliveryAddressService.addressList$);
  protected readonly loading = toSignal(this.deliveryAddressService.loading$);
  protected readonly isMobileSmDown = toSignal(this.deviceService.isMobileSmDown$);

  ngOnInit(): void {
    merge(this.deliveryAddressService.selectActiveAddressIdEvent, this.deliveryAddressService.savedAddressEvent)
      .pipe(delay(50), takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.modalService.closeActiveModal();
      });
  }

  openModal(): void {
    this.modalService.open(DeliveryAddressDialogComponent, {
      modalType: { xxs: 'fullscreen', lg: 'standard' },
      maxWidth: { lg: '1240px' },
    });
  }
}
